import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { usePartner } from "@/context/PartnerContext";

const scrollToForm = () => {
  document.getElementById("cotizar")?.scrollIntoView({ behavior: "smooth" });
};

const CobrandInline = ({ config, sizeCls }) => {
  if (!config) return null;
  return (
    <div
      data-testid="header-partner-cobrand"
      className="flex items-center gap-3 sm:gap-4 md:gap-6"
    >
      <span className="hidden sm:block text-[10px] font-medium uppercase tracking-wider text-gray-400 leading-none">
        en alianza<br />con
      </span>
      {(config.logos && config.logos.length > 0) ? (
        <div className="flex items-center gap-4 sm:gap-6 md:gap-8">
          {config.logos.map((l, i) => (
            <img
              key={i}
              src={l.src}
              alt={l.alt}
              className={`w-auto ${l.className || sizeCls}`}
            />
          ))}
        </div>
      ) : config.logoChip ? (
        <span className={`inline-flex items-center rounded-md px-2 py-1 ${config.logoChip}`}>
          <img src={config.logo} alt={config.name} className={`w-auto ${sizeCls}`} />
        </span>
      ) : (
        <img src={config.logo} alt={config.name} className={`w-auto ${sizeCls}`} />
      )}
    </div>
  );
};

export const Header = () => {
  const { config, linkBase } = usePartner();

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 border-b border-gray-200/80 bg-white/80 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        {/* FILA PRINCIPAL */}
        <div className="h-16 sm:h-24 flex items-center justify-between gap-2">
          <div className="flex items-center min-w-0 gap-3 md:gap-6">
            <a href="#top" data-testid="brand-logo" className="flex items-center shrink-0">
              <img
                src="/brand/logo.png"
                alt="MiMaquinaSegura.cl — Seguros para maquinaria, equipos y tecnología"
                className="h-9 sm:h-16 md:h-[72px] w-auto"
              />
            </a>
            {/* En md+ el cobrand va inline al lado del brand */}
            {config && (
              <div className="hidden md:flex items-center pl-4 md:pl-6 border-l border-gray-300">
                <CobrandInline config={config} sizeCls="h-8 sm:h-10 md:h-12" />
              </div>
            )}
          </div>

          <div className="flex items-center gap-2 sm:gap-4 shrink-0">
            <Link
              to={`${linkBase}/siniestro`}
              data-testid="header-siniestro-link"
              className="hidden sm:inline-flex items-center h-11 rounded-full border border-gray-300 bg-white px-5 text-sm font-semibold text-brand-ink hover:border-brand-yellow hover:text-brand-yellow transition-colors"
            >
              Gestionemos tu siniestro
            </Link>
            <Button
              data-testid="header-cotizar-btn"
              onClick={scrollToForm}
              className="group h-9 sm:h-11 rounded-full bg-brand-ink hover:bg-brand-inkHover text-white text-xs sm:text-sm font-semibold pl-3 sm:pl-5 pr-1.5 sm:pr-2 gap-1.5 sm:gap-2 transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-brand-ink/25 hover:shadow-xl hover:shadow-brand-ink/40"
            >
              <span className="sm:hidden">Cotizar</span>
              <span className="hidden sm:inline">Cotizar mi seguro</span>
              <span className="flex h-6 w-6 sm:h-7 sm:w-7 items-center justify-center rounded-full bg-brand-yellow text-brand-ink transition-transform duration-300 group-hover:translate-x-0.5">
                <ArrowRight className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              </span>
            </Button>
          </div>
        </div>

        {/* FILA COBRAND — solo mobile/tablet, oculto en md+ (arriba va inline) */}
        {config && (
          <div
            data-testid="header-partner-cobrand-mobile"
            className="md:hidden flex items-center justify-center gap-4 sm:gap-6 pb-2 pt-0"
          >
            <span className="text-[9px] sm:text-[10px] font-medium uppercase tracking-wider text-gray-400 leading-none whitespace-nowrap">
              en alianza con
            </span>
            <div className="flex items-center gap-4 sm:gap-6">
              {(config.logos && config.logos.length > 0)
                ? config.logos.map((l, i) => (
                    <img key={i} src={l.src} alt={l.alt} className="h-7 sm:h-10 w-auto" />
                  ))
                : config.logo && (
                    <img src={config.logo} alt={config.name} className="h-7 sm:h-10 w-auto" />
                  )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
